import styled from 'styled-components';

interface ButtonProps {
  disabled?: boolean;
  green?: boolean;
  fullWidth?: boolean;
}

export const Button = styled.div.attrs({
  className: 'Button',
})<ButtonProps>(
  ({ disabled, green, fullWidth }) => `
    background: ${disabled ? 'none' : green ? '#28a745' : '#cc2020'};
    color: ${disabled ? '#999' : '#ccc'};
    border-radius: 5px;
    height: 32px;
    width: ${fullWidth ? '100%' : 'calc(50% - 5px)'}; 
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: ${disabled ? 'default' : 'pointer'};
    &:hover {
      opacity: 0.8;
    }
    > a {
      all: unset;
      display: flex;
      gap: 0.5em;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
    }
  `
);

export const ButtonsContainer = styled.div.attrs({
  className: 'ButtonsContainer',
})`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ReferencesContainer = styled.div`
  padding: 10px 10px 30px 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PredictionItem = styled.div`
  background: #f0f0f0;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 12px 16px;
  margin: 8px 0;
  width: 100%;
`;

export const Subtitle = styled.div.attrs({
  className: 'Subtitle',
})`
  border-radius: 5px 10px 0 0;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-direction: column;
  color: white;
  &:after {
    content: '';
    height: 5px;
    width: 80%;
    border-bottom: 1px solid gray;
  }
`;

export const ToggleContainer = styled.div.attrs({
  className: 'ToggleContainer',
})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 5px;
  cursor: pointer;
  border-radius: 5px;
  &:hover {
    background: #aaa;
  }
`;

export const ToggleSectionContainer = styled.div.attrs({
  className: 'ToggleSectionContainer',
})`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #192225;
  border-radius: 5px;
  padding: 5px;
  margin-top: 10px;
`;
export const Spacer = styled.div.attrs({
  className: 'Spacer',
})`
  height: 5px; /* Vertical space */
`;

interface CheckboxProps {
  isSystolic?: boolean;
  isDiastolic?: boolean;
  isMidSystole?: boolean;
  isPreDiastole?: boolean;
}

interface OptionContainerProps {
  isSelected?: boolean;
}

export const Checkbox = styled.input.attrs({
  className: 'Checkbox',
  type: 'checkbox',
})<CheckboxProps>(
  ({ color }) => `  
    margin: 0 2px;
    cursor: pointer;
    accent-color: ${color};
  `
);

export const OptionContainer = styled.div.attrs({
  className: 'OptionContainer',
})<OptionContainerProps>(
  ({ isSelected }) => `
    color: white;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0.75em 1em;
    cursor: pointer;
    font-size: 12px;
    background: ${isSelected ? 'lightpink' : 'none'};
    &:hover {
      background: ${isSelected ? 'pink' : 'lightgray'};
    }
  `
);

export const NoReferencesContainer = styled.div.attrs({
  className: 'NoReferencesContainer',
})`
  color: #fff;
  font-size: 14px;
  text-align: center;
  padding: 20px;
`;
